import { render, staticRenderFns } from "./BudgetAgencyItem.vue?vue&type=template&id=4d108a41&scoped=true&"
import script from "./BudgetAgencyItem.vue?vue&type=script&lang=js&"
export * from "./BudgetAgencyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d108a41",
  null
  
)

export default component.exports